import React from 'react';

import { IconLoader, IconSearch } from '@tabler/icons';
import { Container, Input, Button } from './styles';

interface SearchInputProps {
  name?: string;
  placeholder?: string;
  isLoading?: boolean;
  [x: string]: any;
  onSubmit: () => void;
}

const SearchInput: React.FC<SearchInputProps> = ({
  name,
  onSubmit,
  isLoading,
  ...rest
}) => {
  return (
    <Container onSubmit={(e: any) => e.preventDefault()}>
      <Input {...rest} />

      <Button type="submit" onClick={onSubmit}>
        {isLoading ? (
          <IconLoader className="spin" size={20} />
        ) : (
          <IconSearch size={20} />
        )}
      </Button>
    </Container>
  );
};

export default SearchInput;
